import { decryptWithAES, encryptWithAES } from "utils/parse";
import http from "../../index";
import { PaginationResponse, SuccessResponse } from "types";
import { Admin, AuthLog, AuthLogFilter, LoginData, LoginResponse } from "./types";

namespace auth {
  const userKey = "app.user";
  const tokenKey = "app.token";
  const orgKey = "org.id";
  const isFilterOrgKey = "is_filter_org";
  const maskCurrencyKey = "mask_currency";

  export const saveToken = (token: string) => {
    localStorage.setItem(tokenKey, token);
  };

  export const rememberUser = (values: LoginData) => {
    if (values.remember) {
      localStorage.setItem(userKey, encryptWithAES(JSON.stringify(values)));
    } else {
      localStorage.removeItem(userKey);
    }
  };

  export const getRememberUser = () => {
    const userData = localStorage.getItem(userKey);
    if (userData) {
      const _userData = JSON.parse(decryptWithAES(userData)) as LoginData;
      return _userData;
    }
    return undefined;
  };

  export const remToken = () => {
    localStorage.removeItem(tokenKey);
  };

  export const hasToken = () => !!localStorage.getItem(tokenKey);

  export const getToken = () => localStorage.getItem(tokenKey);

  export const setIsFilterOrg = (isFilter: string) => {
    localStorage.setItem(isFilterOrgKey, isFilter);
  };

  export const getIsFilterOrg = () => localStorage.getItem(isFilterOrgKey);

  export const setMaskCurrency = (mask: boolean) => {
    localStorage.setItem(maskCurrencyKey, mask ? "1" : "0");
  };

  export const getMaskCurrency = () =>
    localStorage.getItem(maskCurrencyKey) === "1";

  export const setOrg = (id: string | undefined) => {
    if (id) localStorage.setItem(orgKey, id);
  };

  export const getOrg = () => localStorage.getItem(orgKey);

  export const info = () =>
    http.get<Admin>("/admin/auth/info", { hasAuth: true });

  export const login = (body: LoginData) =>
    http.post<LoginResponse>("/admin/auth/login", {
      body,
    });

  export const verifyPassword = (password: string) =>
    http.post<SuccessResponse>("/admin/auth/verify-password", {
      hasAuth: true,
      body: { password },
    });

  export const logs = {
    call: (body: AuthLogFilter) => {
      return http.post<PaginationResponse<AuthLog>>("/admin/auth/logs/page", {
        hasAuth: true,
        body,
      });
    },
    permission: "auth_logs_list",
  };
}

export default auth;
